import SelectPrimitive from './SelectPrimitive';
import { ISelectPrimitive } from './SelectPrimitive.interface';

export default SelectPrimitive;
export { SelectPrimitive, ISelectPrimitive };
